import { render, staticRenderFns } from "./ViewSettingsEditor.vue?vue&type=template&id=d6f1a7b6"
import script from "./ViewSettingsEditor.vue?vue&type=script&lang=ts"
export * from "./ViewSettingsEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports